import Api from '@/services/Api'
import { getFormData } from '@/utils/utils'

export default {
  getLocations () {
    return Api().get('/api/v1/locations')
  },

  addLocation (params) {
    const data = getFormData(params)
    return Api().post('/api/v1/locations', data, {
      withCredentials: true
    })
  },

  async updateLocation (params) {
    const data = getFormData(params)
    return Api().put(`/api/v1/locations/${params._id}`, data, {
      withCredentials: true
    })
  },

  getLocation (id) {
    return Api().get(`/api/v1/locations/${id}`)
  },

  deleteLocation (id) {
    return Api().delete(`/api/v1/locations/${id}`, {
      withCredentials: true
    })
  }
}
